import React from "react";
import "../styles/subwayAnimation.scss";

export const SubwayAnimation = () => {
  return (
    <>
    <div className="trains">
    <div className="train">
      <div className="roof"></div>
      <div className="line"></div>
      <div className="line line-big"></div>
      <div className="windows windows-small">
        <div className="window window-small"></div>
        <div className="window window-small"></div>
      </div>
      <div className="windows windows-big">
        <div className="window window-big"></div>
        <div className="window window-big"></div>
      </div>
      <div className="doors">
        <div className="door">
          <div className="window window-door"></div>
          <div className="window window-door"></div>
        </div>
        <div className="door">
          <div className="window window-door"></div>
          <div className="window window-door"></div>
        </div>
      </div>
      <div className="floor">
        <div className="wheel-wrapper">
          <div className="wheels">
            <div className="wheel"></div>
            <div className="wheel"></div>
          </div>
          <div className="wheels">
            <div className="wheel"></div>
            <div className="wheel"></div>
          </div>
        </div>
        <div className="box box-big"></div>
        <div className="box box-small"></div>
      </div>
    </div>
    <div className="train">
      <div className="roof"></div>
      <div className="line"></div>
      <div className="line line-big"></div>
      <div className="windows windows-small">
        <div className="window window-small"></div>
        <div className="window window-small"></div>
      </div>
      <div className="windows windows-big">
        <div className="window window-big"></div>
        <div className="window window-big"></div>
      </div>
      <div className="doors">
        <div className="door">
          <div className="window window-door"></div>
          <div className="window window-door"></div>
        </div>
        <div className="door">
          <div className="window window-door"></div>
          <div className="window window-door"></div>
        </div>
      </div>
      <div className="floor">
        <div className="wheel-wrapper">
          <div className="wheels">
            <div className="wheel"></div>
            <div className="wheel"></div>
          </div>
          <div className="wheels">
            <div className="wheel"></div>
            <div className="wheel"></div>
          </div>
        </div>
        <div className="box box-big"></div>
        <div className="box box-small"></div>
      </div>
    </div>
    <div className="train">
      <div className="roof"></div>
      <div className="line"></div>
      <div className="line line-big"></div>
      <div className="windows windows-small">
        <div className="window window-small"></div>
        <div className="window window-small"></div>
      </div>
      <div className="windows windows-big">
        <div className="window window-big"></div>
        <div className="window window-big"></div>
      </div>
      <div className="doors">
        <div className="door">
          <div className="window window-door"></div>
          <div className="window window-door"></div>
        </div>
        <div className="door">
          <div className="window window-door"></div>
          <div className="window window-door"></div>
        </div>
      </div>
      <div className="floor">
        <div className="wheel-wrapper">
          <div className="wheels">
            <div className="wheel"></div>
            <div className="wheel"></div>
          </div>
          <div className="wheels">
            <div className="wheel"></div>
            <div className="wheel"></div>
          </div>
        </div>
        <div className="box box-big"></div>
        <div className="box box-small"></div>
      </div>
    </div>
    <div className="train">
      <div className="roof"></div>
      <div className="line"></div>
      <div className="line line-big"></div>
      <div className="windows windows-small">
        <div className="window window-small"></div>
        <div className="window window-small"></div>
      </div>
      <div className="windows windows-big">
        <div className="window window-big"></div>
        <div className="window window-big"></div>
      </div>
      <div className="doors">
        <div className="door">
          <div className="window window-door"></div>
          <div className="window window-door"></div>
        </div>
        <div className="door">
          <div className="window window-door"></div>
          <div className="window window-door"></div>
        </div>
      </div>
      <div className="floor">
        <div className="wheel-wrapper">
          <div className="wheels">
            <div className="wheel"></div>
            <div className="wheel"></div>
          </div>
          <div className="wheels">
            <div className="wheel"></div>
            <div className="wheel"></div>
          </div>
        </div>
        <div className="box box-big"></div>
        <div className="box box-small"></div>
      </div>
    </div>
  </div>
  
    <div className="wrapper">

    </div>
    </>
  );
};
